import React from 'react'

import { Skeleton } from '@mui/material'
import { useWeeklyReportsCredits } from 'features/customers/hooks/useWeeklyReportCredits'

import QuotaUsage from 'components/_base/QuotaUsage'

import UsageUnavailable from './UsageUnavailable'

const CustomerBomboraCompaniesUsage = () => {
  const { credits, isLoading, isError } = useWeeklyReportsCredits()

  if (isError) {
    return <UsageUnavailable />
  }

  return isLoading ? (
    <Skeleton variant="text" width={85} />
  ) : (
    <QuotaUsage quota={credits?.totalCredits} usage={credits?.usedCredits} />
  )
}

export default CustomerBomboraCompaniesUsage
